import { handleResponse, Headers } from "../_helpers";

export const ImageService = {
  getImagesByWorld,
  getImagesByChronicle,
  uploadImage,
  updateImage,
  deleteImage,
  deleteMultipleImages,
};

function getImagesByWorld(worldID) {
  const request = {
    method: "GET",
    headers: Headers.set({ auth: false }),
  };

  return fetch(`${process.env.API_URL}/api/v1/image/world/${worldID}`, request)
    .then(handleResponse)
    .then((images) => images);
}

function getImagesByChronicle(chronicleID) {
  const request = {
    method: "GET",
    headers: Headers.set({ auth: false }),
  };

  return fetch(
    `${process.env.API_URL}/api/v1/image/chronicle/${chronicleID}`,
    request
  )
    .then(handleResponse)
    .then((images) => images);
}

function uploadImage(imageData) {
  const request = {
    method: "POST",
    // headers: { 'Content-Type': 'multipart/form-data' },
    headers: Headers.set({ ignoreType: true, auth: true }),
    // body: JSON.stringify(imageData),
    body: imageData,
  };
  return fetch(`${process.env.API_URL}/api/v1/image/upload`, request)
    .then(handleResponse)
    .then((images) => images);
}

function updateImage(imageID, imageData) {
  const request = {
    method: "PUT",
    headers: Headers.set({ ignoreType: true, auth: true }),
    // headers: { 'Content-Type': 'application/json' },
    // body: JSON.stringify(imageData),
    body: imageData,
  };

  return fetch(`${process.env.API_URL}/api/v1/image/${imageID}`, request)
    .then(handleResponse)
    .then((image) => image);
}

function deleteImage(imageID) {
  const request = {
    method: "DELETE",
    headers: Headers.set(),
  };

  return fetch(`${process.env.API_URL}/api/v1/image/${imageID}`, request)
    .then(handleResponse)
    .then((image) => image);
}

function deleteMultipleImages(imageIDs) {
  const request = {
    method: "DELETE",
    headers: Headers.set(),
    body: JSON.stringify(imageIDs),
  };

  return fetch(`${process.env.API_URL}/api/v1/image`, request)
    .then(handleResponse)
    .then((result) => result);
}
